import { gql } from '@apollo/client';
import { getRichTextQueryString } from './utils';

export const getHelpDrawerCollection = gql`
query getHelpDrawerCollection($lang: String, $id: String) {
  helpDrawerCollection(
    locale: $lang
    limit: 1
    where: { id: $id }
  ) {
    items {
        id
        helpDrawerTitle(locale: $lang)
        headline(locale: $lang)
        helpDrawerRichText(locale: $lang){
          ${getRichTextQueryString()}
        }
        helpDrawerSecondText(locale: $lang){
          ${getRichTextQueryString()}
        }
		helpDrawerThirdText(locale: $lang){
          ${getRichTextQueryString()}
        }
      }
    }
}
`;
